<div>
  <p>
    <strong>Azonosító: {{ selectedVehicle.regist }}</strong>
  </p>
  <p>Sebesség: {{ selectedVehicle.speed }} kph</p>
  <p>Magasság: {{ selectedVehicle.altitude }} m</p>
  <p *ngIf="selectedVehicle.vz">Vario: {{ selectedVehicle.vz }} m/s</p>
  <p>Vevőállomás: {{ selectedVehicle.receiver }}</p>
  <p>Légijármű típusa: {{ aircraftTypeStringMap[selectedVehicle.type] }}</p>
</div>
<div>
  <button class="none" [disabled]="true" mat-icon-button>
    <mat-icon aria-hidden="false">favorite</mat-icon>
  </button>

  <button matTooltip="Követés" mat-icon-button (click)="follow()">
    <mat-icon aria-hidden="false">timeline</mat-icon>
  </button>

  <button matTooltip="Üzenet küldés" mat-icon-button (click)="send()">
    <mat-icon aria-hidden="false">send</mat-icon>
  </button>
</div>
